import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "page-content" };
import FooterNav from '@/layout/dashboard/footer.vue';
import UpdateNotification from '@/layout/dashboard/partials/update-notification.vue';
import Navbar from './navbar.vue';
import Sidebar from './sidebar.vue';
import TrialBar from '@/layout/dashboard/partials/trial-bar.vue';
import PromoBar from '@/layout/dashboard/partials/promo-bar.vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth.ts';
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import CompanyChangeNotification from '@/layout/dashboard/partials/company-change-notification.vue';
import EmployeeNoPlanBar from '@/layout/dashboard/partials/employee-no-plan-bar.vue';
import PersonalizationGuide from '@/modals/personalization-guide/manage.vue';
import { useSubscriptionStore } from '@/stores/subscription';
export default /*@__PURE__*/ _defineComponent({
    __name: 'wrapper',
    setup(__props) {
        const SeatCheckoutForm = defineAsyncComponent(() => import('@/pages/subscription/seat-checkout/seat-checkout-form.vue'));
        const CheckoutModal = defineAsyncComponent(() => import('@/modals/subscription/checkout-modal.vue'));
        const SubscriptionComparisonModal = defineAsyncComponent(() => import('@/modals/subscription/subscription-comparison-modal.vue'));
        const UserAgreementModal = defineAsyncComponent(() => import('@/modals/user/gdpr/manage.vue'));
        const SmartIdModal = defineAsyncComponent(() => import('@/pages/smart-id/smart-id-modal.vue'));
        const UserVerifyModal = defineAsyncComponent(() => import('@/modals/user-verify/manage.vue'));
        const route = useRoute();
        const authStore = useAuthStore();
        const subscriptionStore = useSubscriptionStore();
        const routeName = computed(() => route.name);
        const userGdpr = computed(() => { var _a, _b; return !((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.gdpr); });
        const showSmartIdSuccess = computed(() => route.query.smartid === 'success');
        const smartIdVisible = ref(false);
        onMounted(() => {
            var _a;
            if (showSmartIdSuccess.value) {
                smartIdVisible.value = true;
            }
            if (((_a = route.query) === null || _a === void 0 ? void 0 : _a.show_subscriptions) && !subscriptionStore.modalVisible) {
                subscriptionStore.setModalVisible(true);
            }
            // Reopen the checkout popup after returning from the Stripe billing portal.
            if (sessionStorage.getItem('reopen_checkout')) {
                sessionStorage.removeItem('reopen_checkout');
                subscriptionStore.setModalVisible(true);
            }
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(authStore).showTrialBar)
                    ? (_openBlock(), _createBlock(TrialBar, { key: 0 }))
                    : _createCommentVNode("", true),
                (_unref(authStore).showPromoBar)
                    ? (_openBlock(), _createBlock(PromoBar, { key: 1 }))
                    : _createCommentVNode("", true),
                (_unref(authStore).showEmployeeNoPlanBar)
                    ? (_openBlock(), _createBlock(EmployeeNoPlanBar, { key: 2 }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["navbar-top d-flex flex-1 flex-column", { 'navbar-top-trial': _unref(authStore).showAnyBar }])
                }, [
                    _createVNode(Navbar),
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(Sidebar),
                        _createElementVNode("main", {
                            class: _normalizeClass(["content-wrapper", routeName.value === 'import.invoices.create' ? 'overflow-visible' : ''])
                        }, [
                            _createVNode(_component_router_view),
                            _createVNode(FooterNav)
                        ], 2)
                    ]),
                    _createVNode(UpdateNotification),
                    _createVNode(CompanyChangeNotification),
                    _cache[0] || (_setBlockTracking(-1, true),
                        (_cache[0] = _createElementVNode("div", { id: "og-sidebar-backdrop" })).cacheIndex = 0,
                        _setBlockTracking(1),
                        _cache[0]),
                    (_unref(authStore).user && userGdpr.value)
                        ? (_openBlock(), _createBlock(_unref(UserAgreementModal), {
                            key: 0,
                            modelValue: userGdpr.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((userGdpr).value = $event))
                        }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(CheckoutModal), {
                        modelValue: _unref(subscriptionStore).modalVisible,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(subscriptionStore).modalVisible) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(SubscriptionComparisonModal), {
                        modelValue: _unref(subscriptionStore).showComparison,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(subscriptionStore).showComparison) = $event))
                    }, null, 8, ["modelValue"]),
                    (showSmartIdSuccess.value)
                        ? (_openBlock(), _createBlock(_unref(SmartIdModal), {
                            key: 1,
                            modelValue: smartIdVisible.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((smartIdVisible).value = $event)),
                            success: ""
                        }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(SmartIdModal), {
                        modelValue: _unref(authStore).smartIdModalVisible,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(authStore).smartIdModalVisible) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(PersonalizationGuide, {
                        modelValue: _unref(authStore).onboardingGuideVisible,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(authStore).onboardingGuideVisible) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(UserVerifyModal), {
                        modelValue: _unref(authStore).userVerifyModalVisible,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(authStore).userVerifyModalVisible) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(subscriptionStore).isSeatCheckoutVisible)
                        ? (_openBlock(), _createBlock(_unref(SeatCheckoutForm), {
                            key: 2,
                            modelValue: _unref(subscriptionStore).isSeatCheckoutVisible,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(subscriptionStore).isSeatCheckoutVisible) = $event))
                        }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                ], 2)
            ], 64));
        };
    }
});
